import { message } from "ant-design-vue";
const toast_success_type = "success";
const toast_warning_type = "warning";
const toast_error_type = "error";

const showToast = (msg: string, type?: string): void => {
  switch (type) {
    case "success":
      message.success(msg);
      break;
    case "warning":
      message.warning(msg);
      break;
    case "error":
      message.error(msg);
      break;
    default:
      message.info(msg);
      break;
  }
};
export { toast_success_type, toast_warning_type, toast_error_type, showToast };
